class BusinessLogin {
  constructor() {
    if(navigator.cookieEnabled){
      const is_active = localStorage.getItem("buss_user");
      if (!cn(is_active)) {
        if(cn(this.getUrlVars().target)){
          location.href = "/pages/wholesale-dashboard";
        }else{
          location.href = "/pages/wholesale-dashboard"+"?target="+that.getUrlVars().target+"";
        }
      }
      this.dataEvents(this);
   }else{
      alert("Cookies are currently disabled in your browser. Please enable cookies to continue.");
   }
  }
  dataEvents(that){
    document.addEventListener("submit", function(e) {
      if (e.target.closest(".tayst-business-login-form")) {
        e.preventDefault();
        const form = e.target.closest(".tayst-business-login-form");
        const userName = form.querySelector("[name='user_name']").value;
        const userPass = form.querySelector("[name='password']").value;
        const submitBtn = form.querySelector(".tayst-business-login-btn");
        submitBtn.setAttribute('disabled',true);
        submitBtn.setAttribute('loading',true);
        fetch(tayst.interfaceBusinessLogin, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            shopid: tayst.shopid,
            user_name: userName,
            password: userPass,
            shopify_customer_id: tayst.shopifycustomerid,
          }).toString(),
        }).then((res) => res.text()).then((ret) => {
          ret = JSON.parse(ret);
          if (ret.status == 0) {
            localStorage.setItem("buss_user", ret.data);
            const target = that.getUrlVars().target;
            if (!target) {
              window.location.href = "/pages/wholesale-dashboard";
            } else {
              window.location.href =
                "/pages/wholesale-dashboard?target=" + target;
            }
          } else {
            const responseCont = form.querySelector(".business-login-response");
            responseCont.innerHTML = ret.msg;
            responseCont.style.display = "block";
            window.scrollTo({
              top: form.getBoundingClientRect().top + window.scrollY - 150,
              behavior: "smooth",
            });
          }
        }).finally(() => {
          setTimeout(function(){
          submitBtn.removeAttribute('disabled');
          submitBtn.setAttribute('loading',false);
          },2000);
        });
      }
      if (e.target.closest(".busi-forgot-pass-form")) {
        e.preventDefault();
        const form = e.target.closest(".busi-forgot-pass-form");
        const submitBtn = form.querySelector("[type='submit']");
        const emailVal = form.querySelector("[name='forgot_pass_email']").value;
        submitBtn.setAttribute('disabled',true);
        submitBtn.setAttribute('loading',true);
        fetch(tayst.businessRetrievePassword, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            email_id: emailVal,
          }).toString(),
        }).then((res) => res.text()).then((ret) => {
          if (!cn(ret)) {
            ret = JSON.parse(ret);
            if (ret.status === 0) {
              form.querySelector(
                ".busi-forgot-pass-success"
              ).style.display = "block";
              form.reset();
            } else {
              const err = form.querySelector(".busi-forgot-pass-err");
              err.textContent = ret.msg;
              err.style.display = "block";
            }
            if (window.$ && $.fancybox) {
              $.fancybox.update();
            }
            setTimeout(() => {
              const response = form.querySelector(
                ".busi-forgot-pass-response"
              );
              if (response) response.style.display = "none";
              if (window.$ && $.fancybox) {
                $.fancybox.update();
              }
            }, 5000);
          }
        })
        .finally(() => {
          submitBtn.removeAttribute('disabled');
          submitBtn.setAttribute('loading',false);
        });
      }
    });
  }
  getUrlVars() {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
      vars[key] = decodeURIComponent(value);
    });
    return vars;
  }
}
new BusinessLogin();